import React from "react";
import "../../styles/ServicesSection/ServicesCards.scss";
import { Service, ServiceCard } from "./ServiceCard";
import { useTranslation } from "react-i18next";

const Services: React.FC = () => {
  const { t } = useTranslation();

  const services: Service[] = [
    {
      name: t("service_office_spaces"),
      icon: "home-hashtag",
      description: t("service_office_spaces_desc"),
    },
    {
      name: t("service_governmental_license"),
      icon: "bank",
      description: t("service_governmental_license_desc"),
    },
    {
      name: t("service_commercial_registration"),
      icon: "money-tick",
      description: t("service_commercial_registration_desc"),
    },
  ];

  return (
    <div className="services">
      {services.map((service, index) => (
        <ServiceCard
          key={index}
          title={service.name}
          icon={service.icon}
          description={service.description}
        />
      ))}
    </div>
  );
};

export default Services;
